import { IAdviceProduct, IProduct } from '../models/product'
import { BaseUrl } from './base_url_enum'
import Api from './index'
import { IApiResponse } from './index'

type IGetProductsResponse = {
  products: IProduct[]
}

type IGetProductResponse = {
  product: IProduct
}

export const getProducts = () => Api<IApiResponse<IGetProductsResponse>>('GET', 'v2/products', BaseUrl.Claim)

export const getProduct = (globalUid: IProduct['globalUid']) =>
  Api<IApiResponse<IGetProductResponse>>('GET', `v2/products/${globalUid}`, BaseUrl.Claim)

export const getAdviceProducts = (agentNumber: string, relationNumber: number) =>
  Api<IApiResponse<IAdviceProduct[]>>('GET', `intermediary/${agentNumber}/relation/${relationNumber}/advice-request/products`, BaseUrl.Request)
